// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SettingsPreview } from '../SettingsPreview';

export const VersionsPreview: React.FC = () => {
  const nav = useNavigate();
  const go = () => {
    nav('versions', { state: { pageName: 'Current Versions' } });
  };
  return (
    <SettingsPreview
      title="Current versions"
      desc="View currently installed dar verions and details"
      onClick={go}
      enableBodyClick
    />
  );
};
